var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMenuDex = function SvgMenuDex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "dex_24dp")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dex_24dp",
    transform: "translate(-0.004699, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0361446,2.66666667 C6.86645331,2.66666667 2.6746988,6.84583333 2.6746988,12 C2.6746988,17.1541667 6.86645331,21.3333333 12.0361446,21.3333333 C17.2058358,21.3333333 21.3975904,17.1541667 21.3975904,12 C21.3975904,6.84583333 17.2058358,2.66666667 12.0361446,2.66666667 Z M15.9792357,12.2354167 L12.2722703,15.93125 C12.1427146,16.0604167 11.9295745,16.0604167 11.8000188,15.93125 L8.09305346,12.2354167 C7.96349774,12.10625 7.96349774,11.89375 8.09305346,11.7645833 L11.8000188,8.06875 C11.9295745,7.93958333 12.1427146,7.93958333 12.2722703,8.06875 L15.9792357,11.7645833 C16.1087914,11.89375 16.1087914,12.10625 15.9792357,12.2354167 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  })))));
};

export { SvgMenuDex as ReactComponent };
export default __webpack_public_path__ + "64c55a59f81fef25ca41a532a02e019b.svg";